var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "chat-index" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4", staticStyle: { "padding-right": "0px" } },
          [
            _c("div", { staticClass: "chat-sidebar" }, [
              _c("h3", [_vm._v("Chats")]),
              _c("input", {
                attrs: { type: "text", placeholder: "Search conversations" }
              }),
              _c("div", { staticClass: "tabs" }, [
                _c(
                  "h6",
                  {
                    staticClass: "ongoing-con",
                    class: { actTab: _vm.activeTab === "unresolved" },
                    on: {
                      click: function($event) {
                        _vm.activeTab = "unresolved"
                      }
                    }
                  },
                  [_vm._v("Unresolved (" + _vm._s(_vm.unresolvedCount) + ")")]
                ),
                _c(
                  "h6",
                  {
                    staticClass: "ongoing-con",
                    class: { actTab: _vm.activeTab === "resolved" },
                    on: {
                      click: function($event) {
                        _vm.activeTab = "resolved"
                      }
                    }
                  },
                  [_vm._v("Resolved (" + _vm._s(_vm.resolvedCount) + ")")]
                )
              ]),
              _c("div", { staticClass: "clearfix" }),
              _c("div", { staticClass: "chat-box" }, [
                _vm.activeTab === "unresolved"
                  ? _c(
                      "div",
                      _vm._l(_vm.unresolvedUsers, function(chatUser) {
                        return _c("div", { key: chatUser.id }, [
                          chatUser.chat != "Admin chat"
                            ? _c(
                                "div",
                                {
                                  staticClass: "chatBox",
                                  class: {
                                    active:
                                      _vm.$route.params.userId == chatUser.id
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/sadmin/user-chat/" + chatUser.id
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-3",
                                            staticStyle: {
                                              "padding-right": "11px"
                                            }
                                          },
                                          [
                                            chatUser.image
                                              ? _c("img", {
                                                  attrs: { src: chatUser.image }
                                                })
                                              : _c("img", {
                                                  attrs: {
                                                    src: "/img/userChat.png"
                                                  }
                                                })
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-9",
                                            staticStyle: {
                                              "padding-left": "0px"
                                            }
                                          },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(chatUser.name))
                                            ]),
                                            _c("h6", [
                                              chatUser.isReceived == 1
                                                ? _c("span", {
                                                    staticClass: "userRep"
                                                  })
                                                : _c("img", {
                                                    staticStyle: {
                                                      "margin-right": "2px"
                                                    },
                                                    attrs: {
                                                      src: "/img/LeftReply.png"
                                                    }
                                                  }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(chatUser.chat) +
                                                  "\n                  "
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.activeTab === "resolved"
                  ? _c(
                      "div",
                      _vm._l(_vm.resolvedUsers, function(chatUser) {
                        return _c("div", { key: chatUser.id }, [
                          _c(
                            "div",
                            {
                              staticClass: "chatBox",
                              class: {
                                active: _vm.$route.params.userId == chatUser.id
                              }
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: "/sadmin/user-chat/" + chatUser.id
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-md-3",
                                        staticStyle: { "padding-right": "11px" }
                                      },
                                      [
                                        chatUser.image
                                          ? _c("img", {
                                              attrs: { src: chatUser.image }
                                            })
                                          : _c("img", {
                                              attrs: {
                                                src: "/img/userChat.png"
                                              }
                                            })
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-md-9",
                                        staticStyle: { "padding-left": "0px" }
                                      },
                                      [
                                        _c("h5", [
                                          _vm._v(_vm._s(chatUser.name))
                                        ]),
                                        _c("h6", [
                                          chatUser.isReceived == 1
                                            ? _c("span", {
                                                staticClass: "userRep"
                                              })
                                            : _c("img", {
                                                staticStyle: {
                                                  "margin-right": "2px"
                                                },
                                                attrs: {
                                                  src: "/img/LeftReply.png"
                                                }
                                              }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(chatUser.chat) +
                                              "\n                  "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.activeTab === "admin"
                  ? _c(
                      "div",
                      _vm._l(_vm.AdminData, function(chatUser) {
                        return _c("div", { key: chatUser.id }, [
                          chatUser.chat == "Admin chat"
                            ? _c(
                                "div",
                                {
                                  staticClass: "chatBox",
                                  class: {
                                    active:
                                      _vm.$route.params.userId == chatUser.id
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/sadmin/user-chat/" + chatUser.id
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-3",
                                            staticStyle: {
                                              "padding-right": "11px"
                                            }
                                          },
                                          [
                                            chatUser.image
                                              ? _c("img", {
                                                  attrs: { src: chatUser.image }
                                                })
                                              : _c("img", {
                                                  attrs: {
                                                    src: "/img/userChat.png"
                                                  }
                                                })
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-9",
                                            staticStyle: {
                                              "padding-left": "0px"
                                            }
                                          },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(chatUser.name))
                                            ]),
                                            _c("h6", [
                                              chatUser.isReceived == 1
                                                ? _c("span", {
                                                    staticClass: "userRep"
                                                  })
                                                : _c("img", {
                                                    staticStyle: {
                                                      "margin-right": "2px"
                                                    },
                                                    attrs: {
                                                      src: "/img/LeftReply.png"
                                                    }
                                                  }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(chatUser.chat) +
                                                  "\n                  "
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "col-md-8", staticStyle: { "padding-left": "0px" } },
          [
            _c("div", { staticClass: "chatHeader" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-md-2",
                    staticStyle: { "padding-right": "0px" }
                  },
                  [
                    _vm.user.image
                      ? _c("img", {
                          staticStyle: {
                            width: "90px",
                            "border-radius": "50%",
                            height: "90px"
                          },
                          attrs: { src: _vm.user.image }
                        })
                      : _c("img", {
                          staticStyle: { "max-width": "80%" },
                          attrs: { src: "/img/userChat.png" }
                        })
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-md-5",
                    staticStyle: { "padding-left": "0px" }
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.user.name))]),
                    _c("h6", [_vm._v(_vm._s(_vm.user.email))])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-md-5",
                    staticStyle: {
                      "text-align": "right",
                      "padding-top": "25px"
                    }
                  },
                  [
                    _c("label", { staticClass: "switch" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ChatStatus.status,
                            expression: "ChatStatus.status"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.ChatStatus.status)
                            ? _vm._i(_vm.ChatStatus.status, null) > -1
                            : _vm.ChatStatus.status
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.ChatStatus.status,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.ChatStatus,
                                      "status",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.ChatStatus,
                                      "status",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.ChatStatus, "status", $$c)
                              }
                            },
                            _vm.MarkAsResolved
                          ]
                        }
                      }),
                      _c("span", { staticClass: "slider" })
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ChatStatus.status == 1
                            ? " Resolved"
                            : " Unresolved"
                        )
                      )
                    ])
                  ]
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "chatList" },
              [
                _vm._l(_vm.chatHistories, function(chatHistory, index) {
                  return _c("div", { key: index }, [
                    index === 0 ||
                    chatHistory.date !== _vm.chatHistories[index - 1].date
                      ? _c("h6", { staticClass: "chatTime" }, [
                          _vm._v(_vm._s(chatHistory.date))
                        ])
                      : _vm._e(),
                    chatHistory.messageFrom == 1
                      ? _c("div", { staticClass: "userChat" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-1",
                                staticStyle: { "padding-right": "0px" }
                              },
                              [
                                _vm.user.image
                                  ? _c("img", {
                                      attrs: { src: _vm.user.image }
                                    })
                                  : _c("img", {
                                      attrs: { src: "/img/userChat.png" }
                                    })
                              ]
                            ),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("h5", [
                                _vm._v(_vm._s(_vm.user.name) + " "),
                                _c("span", [_vm._v(_vm._s(chatHistory.time))])
                              ]),
                              _c("p", [_vm._v(_vm._s(chatHistory.message))])
                            ])
                          ])
                        ])
                      : _c("div", { staticClass: "adminChat" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6" }),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("h5", [
                                _vm._v("Admin "),
                                _c("span", [_vm._v(_vm._s(chatHistory.time))])
                              ]),
                              _c("p", [_vm._v(_vm._s(chatHistory.message))])
                            ])
                          ])
                        ])
                  ])
                }),
                _c("div", { staticClass: "chatMessage" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.message,
                        expression: "message"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Write your message..."
                    },
                    domProps: { value: _vm.message },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.message = $event.target.value
                      }
                    }
                  }),
                  _c("span", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.sentOnEmail,
                          expression: "sentOnEmail"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.sentOnEmail)
                          ? _vm._i(_vm.sentOnEmail, null) > -1
                          : _vm.sentOnEmail
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.sentOnEmail,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.sentOnEmail = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.sentOnEmail = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.sentOnEmail = $$c
                          }
                        }
                      }
                    }),
                    _vm._v("Sent on email")
                  ]),
                  _c(
                    "button",
                    {
                      attrs: { disabled: !_vm.message },
                      on: { click: _vm.sendMessage }
                    },
                    [_c("img", { attrs: { src: "/img/SentIcon.png" } })]
                  )
                ])
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }